import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cash-payment-filters',
  templateUrl: './cash-payment-filters.component.html',
  styleUrls: ['./cash-payment-filters.component.scss']
})
export class CashPaymentFiltersComponent {
  @Input() statusItems: any[] = [];
  @Input() fiscalYearItems: any[] = [];
  @Input() quarterItems: any[] = [];
  @Input() selectedStatus: any = '';
  @Input() selectedFiscalYear: any = '';
  @Input() selectedQuarter: any = '';

  @Output() statusChange = new EventEmitter<any>();
  @Output() fiscalYearChange = new EventEmitter<any>();
  @Output() quarterChange = new EventEmitter<any>();
  @Output() search = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();
  @Output() export = new EventEmitter<void>();

  getCurrentSelectedStatus(): any {
    const found = this.statusItems.find((item: any) => item.id === this.selectedStatus);
    return found ? found : { id: '', name: 'All' };
  }

  getCurrentSelectedFiscalYear(): any {
    const found = this.fiscalYearItems.find((item: any) => item.id === this.selectedFiscalYear);
    return found ? found : { id: '', name: 'All' };
  }

  getCurrentSelectedQuarter(): any {
    const found = this.quarterItems.find((item: any) => item.id === this.selectedQuarter);
    return found ? found : { id: '', name: 'All' };
  }
}
